import React, { useState, useEffect } from "react";
import stylez from "./Delivery.module.css";
import "jspdf-autotable";
import Pdf from "../../Components/Deliveries/pdf/pdf";
import axiosInstance from "../../Configuration/axiosInstance";
import { useNavigate } from "react-router-dom";
import DeliveriesTable from "./DeliveriesTable/DeliveriesTable";
import SearchStrip from "../../Components/Deliveries/SearchStrip/SearchStrip";

const ManageDeliveries = () => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [count, setCount] = useState();
  const [deliveries, setDeliveries] = useState();
  const [loading, setLoading] = useState(true);
  const [stateChanged, setStateChanged] = useState(false);
  const [printSelected, setPrintSelected] = useState([]);
  const [print, setPrint] = useState([]);
  const [show, setShow] = useState(false);
  const [prods, setProds] = useState([]);
  const [order, setOrder] = useState();

  const [searchCriteria, setSearchCriteria] = useState({
    runId: "",
    fromDate: "",
    toDate: "",
  });
  const [clearFilters, setClearFilters] = useState(false);

  const navigate = useNavigate();
  const updateDeliveries = (i) => {
    navigate("/updateDeliveries", { state: i });
  };

  const status = ["Pending"];

  useEffect(() => {
    setLoading(true);

    axiosInstance
      .get(
        `delivery?page=${page}&limit=${pageSize}&fromDate=${searchCriteria.fromDate}&toDate=${searchCriteria.toDate}&deliveryId=${searchCriteria.runId}&status=${status}`
      )
      .then((res) => {
        setDeliveries(res.data.data);
        setCount(res.data.count);
        setLoading(false);
      });
  }, [stateChanged, page, pageSize]);
  const deleteDelivery = (i) => {
    axiosInstance.delete(`delivery/${i}`).then((data) => {
      setStateChanged((prevValue) => !prevValue);
    });
  };
  // Page indexing

  const handleNext = () => {
    setPage((preValue) => preValue + 1);
  };
  const handlePrevious = () => {
    setPage((preValue) => preValue - 1);
  };

  const handleChecked = (e, id) => {
    if (e.target.checked) {
      setPrintSelected((preValues) => [...preValues, e.target.value]);
    } else if (!e.target.checked) {
      setPrintSelected(printSelected.filter((i) => i !== id));
    }
    // Include the first selected item in the print selection
    const printSelection = [...printSelected];
    if (!printSelection.includes(id)) {
      printSelection.push(id);
    }
    setPrint(deliveries.filter((obj) => printSelection.includes(obj._id)));
  };

  const handleProductModal = (products, order) => {
    setProds(products);
    setOrder(order);
    setShow(true);
  };

  const headings = [
    "Select",
    "Run Name",
    "Vehicle Rego",
    "Order Details",
    "Expected Delivery Date",
    "Assigned Drivers",
    "Status",
    "Actions",
  ];

  return (
    <div>
      <div className={stylez.heading}>
        <h2>All Deliveries</h2>

        <SearchStrip
          clearFilters={clearFilters}
          setClearFilters={setClearFilters}
          setStateChanged={setStateChanged}
          searchCriteria={searchCriteria}
          setSearchCriteria={setSearchCriteria}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
        <div style={{ display: "flex", gap: "10px" }}>
          <Pdf data={print} />
          <button
            style={{ backgroundColor: "#007bff", color: "white" }}
            onClick={() => {
              navigate("/deliveries/calculateStock");
            }}
          >
            CalculateStock{" "}
          </button>
        </div>
        {/* Implement a search Strip to search for the deliveries using date or RUN ID */}
      </div>

      <DeliveriesTable
        show={show}
        setShow={setShow}
        order={order}
        prods={prods}
        loading={loading}
        deliveries={deliveries}
        handleChecked={handleChecked}
        handleProductModal={handleProductModal}
        updateDeliveries={updateDeliveries}
        deleteDelivery={deleteDelivery}
        page={page}
        handleNext={handleNext}
        pageSize={pageSize}
        handlePrevious={handlePrevious}
        count={count}
        headings={headings}
      />
    </div>
  );
};
export default ManageDeliveries;
